module.exports = __webpack_public_path__ + "img/positive_impacts.d9eaa162.png";